import { configureStore, combineReducers } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import axios from 'axios';
import EvidenceListReducer from './reducers/evidenceList.js';
import UsersReducer from './reducers/users';
import NotificationsReducer from './reducers/notifications.js';
import SiteReducer from './reducers/site.js'
import WasteCodeReducer from './reducers/wasteCode.js';
import BranchReducer from './reducers/branch.js';
import WasteReducer from './reducers/waste.js';
import ClientReducer from './reducers/client.js';
import AnnouncementReducer from './reducers/announcement.js';
import CompanySearch from './reducers/companySearch.js';
import UiSlice from './reducers/uiSlice.js';
import TenantReducer from './reducers/tenant.js';
import PaymentReducer from './reducers/payment.js';
import InvitationReducer from './reducers/invitation.js';
import ConsentReducer from './reducers/consent.js';
import OperationalLogReducer from './reducers/operationalLog.js';
import OperationalLogEntryReducer from './reducers/operationalLogEntry.js';
import PackagingUnitReducer from './reducers/packagingUnit.js';
import PackagingUnitDocumentReducer from './reducers/packagingUnitDocument.js';
import { removeTokenCookie } from '../utils/tools';

const combinedReducer = combineReducers({
    users: UsersReducer,
    evidenceList: EvidenceListReducer,
    notifications: NotificationsReducer,
    site: SiteReducer,
    wasteCodes: WasteCodeReducer,
    branch: BranchReducer,
    waste: WasteReducer,
    client: ClientReducer,
    announcement: AnnouncementReducer,
    companySearch: CompanySearch,
    uiSlice: UiSlice,
    tenant: TenantReducer,
    payment: PaymentReducer,
    invitation: InvitationReducer,
    consent: ConsentReducer,
    operationalLog: OperationalLogReducer,
    operationalLogEntry: OperationalLogEntryReducer,
    packagingUnit: PackagingUnitReducer,
    packagingUnitDocument: PackagingUnitDocumentReducer,
});

const rootReducer = (state, action) => {
    if (action.type === 'users/signOut/fulfilled') {
        state = undefined;
    }
    return combinedReducer(state, action);
};

export const store = configureStore({
    reducer: rootReducer,
});

axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response?.status === 401) {
            const isAuthCheck = error.config?.url?.includes('/api/auth/isauth');
            if (!isAuthCheck) {
                removeTokenCookie();
                store.dispatch({ type: 'users/signOut/fulfilled' });
                window.location.href = '/account/login';
            }
        }
        // Centralized reporting for every API call in the app — thunks catch this
        // rejection and dispatch a UI toast, but Redux Toolkit's createAsyncThunk
        // swallows the re-thrown error internally, so it never becomes an
        // unhandled rejection Sentry's global handler would otherwise catch.
        // beforeSend (see index.js) still filters out expected < 500 responses.
        Sentry.captureException(error);
        return Promise.reject(error);
    }
);